@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.home.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.home.resources/"

@delegate:ResourceContentHash(-1_866_170_544)
internal val Res.string.home_action_map: StringResource by lazy {
      StringResource("string:home_action_map", "home_action_map", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 219, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 139, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95, 39),
      ))
    }

@delegate:ResourceContentHash(-1_742_868_502)
internal val Res.string.home_action_see_all: StringResource by lazy {
      StringResource("string:home_action_see_all", "home_action_see_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 279, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 187, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135, 39),
      ))
    }

@delegate:ResourceContentHash(1_565_539_437)
internal val Res.string.home_all_canada: StringResource by lazy {
      StringResource("string:home_all_canada", "home_all_canada", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 327, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 227, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175, 39),
      ))
    }

@delegate:ResourceContentHash(1_323_227_404)
internal val Res.string.home_all_usa: StringResource by lazy {
      StringResource("string:home_all_usa", "home_all_usa", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 383, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 271, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215, 32),
      ))
    }

@delegate:ResourceContentHash(157_111_186)
internal val Res.string.home_badge_new: StringResource by lazy {
      StringResource("string:home_badge_new", "home_badge_new", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 436, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 320, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248, 26),
      ))
    }

@delegate:ResourceContentHash(67_808_351)
internal val Res.string.home_choose_city: StringResource by lazy {
      StringResource("string:home_choose_city", "home_choose_city", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 471, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 355, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 275, 44),
      ))
    }

@delegate:ResourceContentHash(-2_046_945_693)
internal val Res.string.home_coming_soon: StringResource by lazy {
      StringResource("string:home_coming_soon", "home_coming_soon", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 524, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 404, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320, 40),
      ))
    }

@delegate:ResourceContentHash(-2_075_604_251)
internal val Res.string.home_country_ca: StringResource by lazy {
      StringResource("string:home_country_ca", "home_country_ca", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 569, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 457, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 361, 31),
      ))
    }

@delegate:ResourceContentHash(406_571_649)
internal val Res.string.home_country_us: StringResource by lazy {
      StringResource("string:home_country_us", "home_country_us", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 609, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 489, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 393, 43),
      ))
    }

@delegate:ResourceContentHash(1_999_728_895)
internal val Res.string.home_discover_title: StringResource by lazy {
      StringResource("string:home_discover_title", "home_discover_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 665, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 529, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 437, 39),
      ))
    }

@delegate:ResourceContentHash(-1_649_446_194)
internal val Res.string.home_distance_ft: StringResource by lazy {
      StringResource("string:home_distance_ft", "home_distance_ft", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 701, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 573, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 477, 40),
      ))
    }

@delegate:ResourceContentHash(1_401_379_534)
internal val Res.string.home_distance_km: StringResource by lazy {
      StringResource("string:home_distance_km", "home_distance_km", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 758, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 614, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 518, 40),
      ))
    }

@delegate:ResourceContentHash(1_827_168_824)
internal val Res.string.home_distance_m: StringResource by lazy {
      StringResource("string:home_distance_m", "home_distance_m", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 880, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 696, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 600, 39),
      ))
    }

@delegate:ResourceContentHash(-200_146_865)
internal val Res.string.home_distance_mi: StringResource by lazy {
      StringResource("string:home_distance_mi", "home_distance_mi", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 823, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 655, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 559, 40),
      ))
    }

@delegate:ResourceContentHash(1_195_463_432)
internal val Res.string.home_empty_desc: StringResource by lazy {
      StringResource("string:home_empty_desc", "home_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 936, 231),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 732, 171),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 640, 135),
      ))
    }

@delegate:ResourceContentHash(1_569_809_133)
internal val Res.string.home_empty_title: StringResource by lazy {
      StringResource("string:home_empty_title", "home_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1168, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 904, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 776, 48),
      ))
    }

@delegate:ResourceContentHash(43_496_302)
internal val Res.string.home_error: StringResource by lazy {
      StringResource("string:home_error", "home_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1245, 126),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 961, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 825, 70),
      ))
    }

@delegate:ResourceContentHash(1_829_074_531)
internal val Res.string.home_event_am: StringResource by lazy {
      StringResource("string:home_event_am", "home_event_am", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1372, 29),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1044, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 896, 25),
      ))
    }

@delegate:ResourceContentHash(-2_006_744_691)
internal val Res.string.home_event_date_format: StringResource by lazy {
      StringResource("string:home_event_date_format", "home_event_date_format", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1402, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1070, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 922, 70),
      ))
    }

@delegate:ResourceContentHash(129_066_643)
internal val Res.string.home_event_free: StringResource by lazy {
      StringResource("string:home_event_free", "home_event_free", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1473, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1141, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 993, 31),
      ))
    }

@delegate:ResourceContentHash(-740_532_473)
internal val Res.string.home_event_image_a11y: StringResource by lazy {
      StringResource("string:home_event_image_a11y", "home_event_image_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1513, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1177, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1025, 57),
      ))
    }

@delegate:ResourceContentHash(2_111_656_951)
internal val Res.string.home_event_pm: StringResource by lazy {
      StringResource("string:home_event_pm", "home_event_pm", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1583, 29),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1243, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1083, 25),
      ))
    }

@delegate:ResourceContentHash(1_336_464_438)
internal val Res.string.home_event_venue_format: StringResource by lazy {
      StringResource("string:home_event_venue_format", "home_event_venue_format", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1613, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1269, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1109, 47),
      ))
    }

@delegate:ResourceContentHash(140_915_793)
internal val Res.string.home_events_card_desc: StringResource by lazy {
      StringResource("string:home_events_card_desc", "home_events_card_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1661, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1317, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1157, 105),
      ))
    }

@delegate:ResourceContentHash(-115_279_250)
internal val Res.string.home_events_card_title: StringResource by lazy {
      StringResource("string:home_events_card_title", "home_events_card_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1791, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1435, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1263, 54),
      ))
    }

@delegate:ResourceContentHash(1_706_115_342)
internal val Res.string.home_explore_people: StringResource by lazy {
      StringResource("string:home_explore_people", "home_explore_people", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1870, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1510, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1318, 35),
      ))
    }

@delegate:ResourceContentHash(1_835_836_002)
internal val Res.string.home_favorite_a11y: StringResource by lazy {
      StringResource("string:home_favorite_a11y", "home_favorite_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1938, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1550, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1354, 46),
      ))
    }

@delegate:ResourceContentHash(1_996_131_779)
internal val Res.string.home_gems_card_desc: StringResource by lazy {
      StringResource("string:home_gems_card_desc", "home_gems_card_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2005, 163),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1609, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1401, 115),
      ))
    }

@delegate:ResourceContentHash(-1_778_186_666)
internal val Res.string.home_gems_card_title: StringResource by lazy {
      StringResource("string:home_gems_card_title", "home_gems_card_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2169, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1725, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1517, 56),
      ))
    }

@delegate:ResourceContentHash(-1_373_994_815)
internal val Res.string.home_language_a11y: StringResource by lazy {
      StringResource("string:home_language_a11y", "home_language_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2242, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1790, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1574, 46),
      ))
    }

@delegate:ResourceContentHash(1_064_350_698)
internal val Res.string.home_language_title: StringResource by lazy {
      StringResource("string:home_language_title", "home_language_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2297, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1841, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1621, 51),
      ))
    }

@delegate:ResourceContentHash(-784_944_236)
internal val Res.string.home_messages_a11y: StringResource by lazy {
      StringResource("string:home_messages_a11y", "home_messages_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2353, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1893, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1673, 38),
      ))
    }

@delegate:ResourceContentHash(910_572_629)
internal val Res.string.home_notifications_a11y: StringResource by lazy {
      StringResource("string:home_notifications_a11y", "home_notifications_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2400, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1932, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1712, 51),
      ))
    }

@delegate:ResourceContentHash(-1_959_377_633)
internal val Res.string.home_people_card_desc: StringResource by lazy {
      StringResource("string:home_people_card_desc", "home_people_card_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2456, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1984, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1764, 101),
      ))
    }

@delegate:ResourceContentHash(-740_057_663)
internal val Res.string.home_people_card_title: StringResource by lazy {
      StringResource("string:home_people_card_title", "home_people_card_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2574, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2098, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1866, 54),
      ))
    }

@delegate:ResourceContentHash(32_138_860)
internal val Res.string.home_people_see_all: StringResource by lazy {
      StringResource("string:home_people_see_all", "home_people_see_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2677, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2153, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1921, 39),
      ))
    }

@delegate:ResourceContentHash(-1_444_079_284)
internal val Res.string.home_rating_badge_a11y: StringResource by lazy {
      StringResource("string:home_rating_badge_a11y", "home_rating_badge_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2725, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2193, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1961, 38),
      ))
    }

@delegate:ResourceContentHash(-2_029_959_231)
internal val Res.string.home_retry: StringResource by lazy {
      StringResource("string:home_retry", "home_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2772, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2240, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2000, 30),
      ))
    }

@delegate:ResourceContentHash(-1_626_883_833)
internal val Res.string.home_search_placeholder: StringResource by lazy {
      StringResource("string:home_search_placeholder", "home_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2819, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2275, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2031, 67),
      ))
    }

@delegate:ResourceContentHash(783_729_274)
internal val Res.string.home_section_categories: StringResource by lazy {
      StringResource("string:home_section_categories", "home_section_categories", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2919, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2359, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2099, 47),
      ))
    }

@delegate:ResourceContentHash(1_025_629_604)
internal val Res.string.home_section_deals: StringResource by lazy {
      StringResource("string:home_section_deals", "home_section_deals", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2971, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2407, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2147, 46),
      ))
    }

@delegate:ResourceContentHash(725_148_440)
internal val Res.string.home_section_events: StringResource by lazy {
      StringResource("string:home_section_events", "home_section_events", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3050, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2470, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2194, 35),
      ))
    }

@delegate:ResourceContentHash(-294_667_430)
internal val Res.string.home_section_explore: StringResource by lazy {
      StringResource("string:home_section_explore", "home_section_explore", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3102, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2514, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2230, 40),
      ))
    }

@delegate:ResourceContentHash(1_342_112_652)
internal val Res.string.home_section_featured: StringResource by lazy {
      StringResource("string:home_section_featured", "home_section_featured", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3143, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2555, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2271, 57),
      ))
    }

@delegate:ResourceContentHash(1_040_232_237)
internal val Res.string.home_section_for_you: StringResource by lazy {
      StringResource("string:home_section_for_you", "home_section_for_you", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3217, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2617, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2329, 40),
      ))
    }

@delegate:ResourceContentHash(1_273_324_432)
internal val Res.string.home_section_gems: StringResource by lazy {
      StringResource("string:home_section_gems", "home_section_gems", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3266, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2658, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2370, 41),
      ))
    }

@delegate:ResourceContentHash(-1_987_347_187)
internal val Res.string.home_section_news: StringResource by lazy {
      StringResource("string:home_section_news", "home_section_news", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3328, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2708, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2412, 45),
      ))
    }

@delegate:ResourceContentHash(40_364_842)
internal val Res.string.home_section_people: StringResource by lazy {
      StringResource("string:home_section_people", "home_section_people", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3382, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2774, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2458, 55),
      ))
    }

@delegate:ResourceContentHash(1_297_852_418)
internal val Res.string.home_section_popular: StringResource by lazy {
      StringResource("string:home_section_popular", "home_section_popular", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3478, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2854, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2514, 52),
      ))
    }

@delegate:ResourceContentHash(1_896_734_237)
internal val Res.string.home_sponsored: StringResource by lazy {
      StringResource("string:home_sponsored", "home_sponsored", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3547, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2923, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2567, 34),
      ))
    }

@delegate:ResourceContentHash(-1_187_157_884)
internal val Res.string.home_ticker_deal: StringResource by lazy {
      StringResource("string:home_ticker_deal", "home_ticker_deal", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3598, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2962, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2602, 44),
      ))
    }

@delegate:ResourceContentHash(591_516_325)
internal val Res.string.home_ticker_news: StringResource by lazy {
      StringResource("string:home_ticker_news", "home_ticker_news", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3643, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3007, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2647, 48),
      ))
    }

@delegate:ResourceContentHash(-379_572_731)
internal val Res.string.home_ticker_person: StringResource by lazy {
      StringResource("string:home_ticker_person", "home_ticker_person", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3696, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3068, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2696, 66),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.news_back_a11y: StringResource by lazy {
      StringResource("string:news_back_a11y", "news_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3791, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3139, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2763, 30),
      ))
    }

@delegate:ResourceContentHash(1_234_339_106)
internal val Res.string.news_detail_title: StringResource by lazy {
      StringResource("string:news_detail_title", "news_detail_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3830, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3170, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2794, 33),
      ))
    }

@delegate:ResourceContentHash(271_264_984)
internal val Res.string.news_image_a11y: StringResource by lazy {
      StringResource("string:news_image_a11y", "news_image_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3872, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3212, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2828, 39),
      ))
    }

@delegate:ResourceContentHash(1_830_957_581)
internal val Res.string.news_list_empty: StringResource by lazy {
      StringResource("string:news_list_empty", "news_list_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3920, 159),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3264, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2868, 95),
      ))
    }

@delegate:ResourceContentHash(-1_944_734_154)
internal val Res.string.news_not_found: StringResource by lazy {
      StringResource("string:news_not_found", "news_not_found", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4080, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3400, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2964, 70),
      ))
    }

@delegate:ResourceContentHash(-1_163_841_536)
internal val Res.string.news_read_more: StringResource by lazy {
      StringResource("string:news_read_more", "news_read_more", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4167, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3471, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3035, 34),
      ))
    }

@delegate:ResourceContentHash(1_550_503_926)
internal val Res.string.news_save_a11y: StringResource by lazy {
      StringResource("string:news_save_a11y", "news_save_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4218, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3514, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3070, 46),
      ))
    }

@delegate:ResourceContentHash(-10_135_045)
internal val Res.string.news_unsave_a11y: StringResource by lazy {
      StringResource("string:news_unsave_a11y", "news_unsave_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4277, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3569, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3117, 48),
      ))
    }

@delegate:ResourceContentHash(-1_199_217_862)
internal val Res.string.notification_campaign: StringResource by lazy {
      StringResource("string:notification_campaign", "notification_campaign", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4354, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3630, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3166, 45),
      ))
    }

@delegate:ResourceContentHash(-1_087_524_028)
internal val Res.string.notification_channel: StringResource by lazy {
      StringResource("string:notification_channel", "notification_channel", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4412, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3688, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3212, 48),
      ))
    }

@delegate:ResourceContentHash(-1_075_720_313)
internal val Res.string.notification_comment: StringResource by lazy {
      StringResource("string:notification_comment", "notification_comment", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4489, 88),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3741, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3261, 68),
      ))
    }

@delegate:ResourceContentHash(-1_540_026_349)
internal val Res.string.notification_event: StringResource by lazy {
      StringResource("string:notification_event", "notification_event", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4578, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3826, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3330, 58),
      ))
    }

@delegate:ResourceContentHash(413_655_409)
internal val Res.string.notification_gem: StringResource by lazy {
      StringResource("string:notification_gem", "notification_gem", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4661, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3901, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3389, 40),
      ))
    }

@delegate:ResourceContentHash(-599_016_717)
internal val Res.string.notification_message: StringResource by lazy {
      StringResource("string:notification_message", "notification_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4714, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3946, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3430, 44),
      ))
    }

@delegate:ResourceContentHash(-1_489_949_495)
internal val Res.string.notification_order: StringResource by lazy {
      StringResource("string:notification_order", "notification_order", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4994, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4182, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3646, 62),
      ))
    }

@delegate:ResourceContentHash(1_835_172_128)
internal val Res.string.notification_order_cancelled: StringResource by lazy {
      StringResource("string:notification_order_cancelled", "notification_order_cancelled", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4767, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3995, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3475, 56),
      ))
    }

@delegate:ResourceContentHash(1_174_995_984)
internal val Res.string.notification_order_confirmed: StringResource by lazy {
      StringResource("string:notification_order_confirmed", "notification_order_confirmed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4836, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4056, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3532, 56),
      ))
    }

@delegate:ResourceContentHash(812_889_427)
internal val Res.string.notification_order_fulfilled: StringResource by lazy {
      StringResource("string:notification_order_fulfilled", "notification_order_fulfilled", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4909, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4121, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3589, 56),
      ))
    }

@delegate:ResourceContentHash(1_762_139_224)
internal val Res.string.notification_other: StringResource by lazy {
      StringResource("string:notification_other", "notification_other", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5085, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4261, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3709, 42),
      ))
    }

@delegate:ResourceContentHash(1_611_666_220)
internal val Res.string.notification_review_reply: StringResource by lazy {
      StringResource("string:notification_review_reply", "notification_review_reply", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5140, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4312, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3752, 77),
      ))
    }

@delegate:ResourceContentHash(812_158_875)
internal val Res.string.notification_time_days_ago: StringResource by lazy {
      StringResource("string:notification_time_days_ago", "notification_time_days_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5246, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4398, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3830, 50),
      ))
    }

@delegate:ResourceContentHash(2_094_969_652)
internal val Res.string.notification_time_hours_ago: StringResource by lazy {
      StringResource("string:notification_time_hours_ago", "notification_time_hours_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5305, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4453, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3881, 51),
      ))
    }

@delegate:ResourceContentHash(-2_012_089_126)
internal val Res.string.notification_time_just_now: StringResource by lazy {
      StringResource("string:notification_time_just_now", "notification_time_just_now", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5369, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4509, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3933, 46),
      ))
    }

@delegate:ResourceContentHash(-1_591_511_977)
internal val Res.string.notification_time_minutes_ago: StringResource by lazy {
      StringResource("string:notification_time_minutes_ago", "notification_time_minutes_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5428, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4564, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3980, 53),
      ))
    }

@delegate:ResourceContentHash(-1_205_191_231)
internal val Res.string.notification_time_weeks_ago: StringResource by lazy {
      StringResource("string:notification_time_weeks_ago", "notification_time_weeks_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5498, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4622, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4034, 51),
      ))
    }

@delegate:ResourceContentHash(306_289_996)
internal val Res.string.notification_unread_a11y: StringResource by lazy {
      StringResource("string:notification_unread_a11y", "notification_unread_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5562, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4682, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4086, 40),
      ))
    }

@delegate:ResourceContentHash(-574_583_101)
internal val Res.string.notifications_back_a11y: StringResource by lazy {
      StringResource("string:notifications_back_a11y", "notifications_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5627, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4723, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4127, 43),
      ))
    }

@delegate:ResourceContentHash(-1_853_666_186)
internal val Res.string.notifications_empty_desc: StringResource by lazy {
      StringResource("string:notifications_empty_desc", "notifications_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5675, 252),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4763, 176),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4171, 132),
      ))
    }

@delegate:ResourceContentHash(-1_323_624_017)
internal val Res.string.notifications_empty_title: StringResource by lazy {
      StringResource("string:notifications_empty_title", "notifications_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5928, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4940, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4304, 61),
      ))
    }

@delegate:ResourceContentHash(-1_005_624_889)
internal val Res.string.notifications_error: StringResource by lazy {
      StringResource("string:notifications_error", "notifications_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6010, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4998, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4366, 67),
      ))
    }

@delegate:ResourceContentHash(371_452_774)
internal val Res.string.notifications_mark_all_read: StringResource by lazy {
      StringResource("string:notifications_mark_all_read", "notifications_mark_all_read", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6106, 131),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5082, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4434, 55),
      ))
    }

@delegate:ResourceContentHash(-2_029_959_231)
internal val Res.string.notifications_retry: StringResource by lazy {
      StringResource("string:notifications_retry", "notifications_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6238, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5146, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4490, 39),
      ))
    }

@delegate:ResourceContentHash(-452_565_039)
internal val Res.string.notifications_signin_action: StringResource by lazy {
      StringResource("string:notifications_signin_action", "notifications_signin_action", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6294, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5190, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4530, 47),
      ))
    }

@delegate:ResourceContentHash(-534_707_647)
internal val Res.string.notifications_signin_desc: StringResource by lazy {
      StringResource("string:notifications_signin_desc", "notifications_signin_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6342, 265),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5242, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4578, 141),
      ))
    }

@delegate:ResourceContentHash(-1_708_189_706)
internal val Res.string.notifications_signin_title: StringResource by lazy {
      StringResource("string:notifications_signin_title", "notifications_signin_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6608, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5424, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4720, 74),
      ))
    }

@delegate:ResourceContentHash(910_572_629)
internal val Res.string.notifications_title: StringResource by lazy {
      StringResource("string:notifications_title", "notifications_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6715, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5515, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4795, 47),
      ))
    }

@delegate:ResourceContentHash(-857_252_211)
internal val Res.string.notifications_unread_count_a11y: StringResource by lazy {
      StringResource("string:notifications_unread_count_a11y", "notifications_unread_count_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6767, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5563, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4843, 75),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("home_action_map", Res.string.home_action_map)
  map.put("home_action_see_all", Res.string.home_action_see_all)
  map.put("home_all_canada", Res.string.home_all_canada)
  map.put("home_all_usa", Res.string.home_all_usa)
  map.put("home_badge_new", Res.string.home_badge_new)
  map.put("home_choose_city", Res.string.home_choose_city)
  map.put("home_coming_soon", Res.string.home_coming_soon)
  map.put("home_country_ca", Res.string.home_country_ca)
  map.put("home_country_us", Res.string.home_country_us)
  map.put("home_discover_title", Res.string.home_discover_title)
  map.put("home_distance_ft", Res.string.home_distance_ft)
  map.put("home_distance_km", Res.string.home_distance_km)
  map.put("home_distance_m", Res.string.home_distance_m)
  map.put("home_distance_mi", Res.string.home_distance_mi)
  map.put("home_empty_desc", Res.string.home_empty_desc)
  map.put("home_empty_title", Res.string.home_empty_title)
  map.put("home_error", Res.string.home_error)
  map.put("home_event_am", Res.string.home_event_am)
  map.put("home_event_date_format", Res.string.home_event_date_format)
  map.put("home_event_free", Res.string.home_event_free)
  map.put("home_event_image_a11y", Res.string.home_event_image_a11y)
  map.put("home_event_pm", Res.string.home_event_pm)
  map.put("home_event_venue_format", Res.string.home_event_venue_format)
  map.put("home_events_card_desc", Res.string.home_events_card_desc)
  map.put("home_events_card_title", Res.string.home_events_card_title)
  map.put("home_explore_people", Res.string.home_explore_people)
  map.put("home_favorite_a11y", Res.string.home_favorite_a11y)
  map.put("home_gems_card_desc", Res.string.home_gems_card_desc)
  map.put("home_gems_card_title", Res.string.home_gems_card_title)
  map.put("home_language_a11y", Res.string.home_language_a11y)
  map.put("home_language_title", Res.string.home_language_title)
  map.put("home_messages_a11y", Res.string.home_messages_a11y)
  map.put("home_notifications_a11y", Res.string.home_notifications_a11y)
  map.put("home_people_card_desc", Res.string.home_people_card_desc)
  map.put("home_people_card_title", Res.string.home_people_card_title)
  map.put("home_people_see_all", Res.string.home_people_see_all)
  map.put("home_rating_badge_a11y", Res.string.home_rating_badge_a11y)
  map.put("home_retry", Res.string.home_retry)
  map.put("home_search_placeholder", Res.string.home_search_placeholder)
  map.put("home_section_categories", Res.string.home_section_categories)
  map.put("home_section_deals", Res.string.home_section_deals)
  map.put("home_section_events", Res.string.home_section_events)
  map.put("home_section_explore", Res.string.home_section_explore)
  map.put("home_section_featured", Res.string.home_section_featured)
  map.put("home_section_for_you", Res.string.home_section_for_you)
  map.put("home_section_gems", Res.string.home_section_gems)
  map.put("home_section_news", Res.string.home_section_news)
  map.put("home_section_people", Res.string.home_section_people)
  map.put("home_section_popular", Res.string.home_section_popular)
  map.put("home_sponsored", Res.string.home_sponsored)
  map.put("home_ticker_deal", Res.string.home_ticker_deal)
  map.put("home_ticker_news", Res.string.home_ticker_news)
  map.put("home_ticker_person", Res.string.home_ticker_person)
  map.put("news_back_a11y", Res.string.news_back_a11y)
  map.put("news_detail_title", Res.string.news_detail_title)
  map.put("news_image_a11y", Res.string.news_image_a11y)
  map.put("news_list_empty", Res.string.news_list_empty)
  map.put("news_not_found", Res.string.news_not_found)
  map.put("news_read_more", Res.string.news_read_more)
  map.put("news_save_a11y", Res.string.news_save_a11y)
  map.put("news_unsave_a11y", Res.string.news_unsave_a11y)
  map.put("notification_campaign", Res.string.notification_campaign)
  map.put("notification_channel", Res.string.notification_channel)
  map.put("notification_comment", Res.string.notification_comment)
  map.put("notification_event", Res.string.notification_event)
  map.put("notification_gem", Res.string.notification_gem)
  map.put("notification_message", Res.string.notification_message)
  map.put("notification_order", Res.string.notification_order)
  map.put("notification_order_cancelled", Res.string.notification_order_cancelled)
  map.put("notification_order_confirmed", Res.string.notification_order_confirmed)
  map.put("notification_order_fulfilled", Res.string.notification_order_fulfilled)
  map.put("notification_other", Res.string.notification_other)
  map.put("notification_review_reply", Res.string.notification_review_reply)
  map.put("notification_time_days_ago", Res.string.notification_time_days_ago)
  map.put("notification_time_hours_ago", Res.string.notification_time_hours_ago)
  map.put("notification_time_just_now", Res.string.notification_time_just_now)
  map.put("notification_time_minutes_ago", Res.string.notification_time_minutes_ago)
  map.put("notification_time_weeks_ago", Res.string.notification_time_weeks_ago)
  map.put("notification_unread_a11y", Res.string.notification_unread_a11y)
  map.put("notifications_back_a11y", Res.string.notifications_back_a11y)
  map.put("notifications_empty_desc", Res.string.notifications_empty_desc)
  map.put("notifications_empty_title", Res.string.notifications_empty_title)
  map.put("notifications_error", Res.string.notifications_error)
  map.put("notifications_mark_all_read", Res.string.notifications_mark_all_read)
  map.put("notifications_retry", Res.string.notifications_retry)
  map.put("notifications_signin_action", Res.string.notifications_signin_action)
  map.put("notifications_signin_desc", Res.string.notifications_signin_desc)
  map.put("notifications_signin_title", Res.string.notifications_signin_title)
  map.put("notifications_title", Res.string.notifications_title)
  map.put("notifications_unread_count_a11y", Res.string.notifications_unread_count_a11y)
}
